import React from 'react';

export type IServiceEnvironmentContext = {
  apiEndpoint: string;
  fileEndpoint: string;
  siteEndpoint: string;
  adminEndpoint: string;
  connectEndpoint: string;
  stripeJsEndpoint: string;
  dashboardEndpoint: string;
};

export const ServiceEnvironmentContext =
  React.createContext<IServiceEnvironmentContext | null>(null);
ServiceEnvironmentContext.displayName = 'ServiceEnvironmentContext';

export const useServiceEnvironment = () => {
  const context = React.useContext(ServiceEnvironmentContext)!;

  const getSiteUrl = React.useCallback(
    (path: string): string => {
      return `${context.siteEndpoint}${path}`;
    },
    [context.siteEndpoint],
  );

  return {
    ...context,
    getSiteUrl,
  };
};
